// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"affdccd87499b11afbab","678":"dc4e59b9e96140f0e6de","883":"b51ed4183234cd9c8cf2"}[chunkId] + ".js";
};